let blogData = [];
let visibleCount = 6;
const blogGrid = document.getElementById("blogGrid");
const loadMoreBtn = document.getElementById("loadMore");
const blogTabs = document.getElementById("blogTabs");
let activeFilter = "all";

// ---------------- FETCH JSON ----------------
fetch("assets/data/blog.json").then(res => res.json()).then(data => {
  // 👉 SORT BY DATE (LATEST FIRST)
  data.sort((a, b) => new Date(b.date) - new Date(a.date));
  blogData = data;
  populateTabs(blogData);
  renderBlogs();
}).catch(err => console.error("Blog JSON Error:", err));

// ---------------- POPULATE TABS ----------------
function populateTabs(data) {
  const categories = new Set(data.map(b => b.category));
  blogTabs.innerHTML = `<button class="active" data-filter="all">All</button>`;
  categories.forEach(cat => {
    blogTabs.innerHTML += `<button data-filter="${cat}">${cat.charAt(0).toUpperCase() + cat.slice(1)}</button>`;
  });

  // Add click event to tabs
  blogTabs.querySelectorAll("button").forEach(btn => {
    btn.addEventListener("click", () => {
      blogTabs.querySelectorAll("button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      activeFilter = btn.getAttribute("data-filter");
      visibleCount = 6; // reset visible count when filter changes
      renderBlogs();
    });
  });
}

// ---------------- RENDER BLOGS ----------------
function renderBlogs() {
  let filteredData = activeFilter === "all" ? blogData : blogData.filter(b => b.category === activeFilter);
  const blogsToShow = filteredData.slice(0, visibleCount);
  blogGrid.innerHTML = "";
  blogsToShow.forEach(blog => {
    const col = document.createElement("div");
    col.className = "col-lg-4 col-md-6 blog-item";
    col.innerHTML = `
            <div class="blog-card">
                <a href="${blog.url}">
                <img src="${blog.image}" class="img-fluid" alt="${blog.title}">
                </a>
                <div class="blog-card-body">
                <div class="cust-w">
                    <span class="badge-tag">${blog.badge}</span>
                    <span class="date">${blog.date}</span>
                </div>
                <h5>${blog.title}</h5>
                <p>${blog.description}</p>
                <a href="${blog.url}" class="readmore">Read more</a>
                </div>
            </div>
            `;
    blogGrid.appendChild(col);
  });

  // Hide Load More if all visible
  loadMoreBtn.style.display = visibleCount >= filteredData.length ? "none" : "inline-block";
}

// ---------------- LOAD MORE ----------------
loadMoreBtn.addEventListener("click", () => {
  visibleCount += 6;
  renderBlogs();
});
document.addEventListener("DOMContentLoaded", function () {
  const blogSection = document.querySelector(".blog-home");
  if (!blogSection) return; // safety guard

  const tabs = blogSection.querySelectorAll(".blog-tabs button");
  const cards = blogSection.querySelectorAll(".blog-item");
  const loadMoreBtn = blogSection.querySelector("#loadMore");
  let currentFilter = "all";
  let visibleCount = 3;
  function showCards() {
    let shown = 0;
    cards.forEach(card => {
      const match = currentFilter === "all" || card.dataset.category === currentFilter;
      if (match && shown < visibleCount) {
        card.style.display = "block";
        gsap.fromTo(card, {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.4,
          overwrite: "auto"
        });
        shown++;
      } else {
        card.style.display = "none";
      }
    });
    const total = Array.from(cards).filter(card => currentFilter === "all" || card.dataset.category === currentFilter).length;
    if (loadMoreBtn) {
      loadMoreBtn.style.display = visibleCount >= total ? "none" : "inline-block";
    }
  }

  // Initial load
  showCards();

  // Tabs click
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
      currentFilter = this.dataset.filter;
      visibleCount = 3;
      showCards();
    });
  });

  // Load more
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      visibleCount += 3;
      showCards();
    });
  }
});